import type { Action } from '../../engine';
import type { Targets } from '../game/viewModel';

/** Keep only the targets whose action the step teaches right now. */
export function filterTargets(t: Targets, allowed: Action[]): Targets {
  const has = (type: Action['type']) => allowed.some((a) => a.type === type);
  const slots = new Set([...t.slots].filter((s) => allowed.some((a) => a.type === t.slotAction && 'slot' in a && a.slot === s)));
  const out: Targets = {
    deck: t.deck && has('drawDeck'),
    discard: t.discard && has('drawDiscard'),
    slots,
    slotAction: slots.size ? t.slotAction : null,
    throwAway: t.throwAway && has('discardDrawn'),
    keepHidden: t.keepHidden && has('skip'),
    nextHole: false,
    any: false,
  };
  out.any = out.deck || out.discard || out.throwAway || out.keepHidden || slots.size > 0;
  return out;
}
